import axios from '../../utils/axios';
import { LIMIT } from '../../utils/config';

const BannerService = {

  async getListBanners(page = 1, limit = LIMIT, search = '') {
    try {
      const response = await axios.get('/banner', {
        params: {
          page,
          limit,
          search,
        }
      })

      return response.data;
    } catch (e) {
      console.log(e);    
      throw e;
    }
  },

  async getById(id) {
    try {
      const response = await axios.get(`/banner/${id}`);
      return response.data;
    } catch (e) {
      console.log(e);    
      throw e;
    }
  },

  async deleteById(id) {
    try {
      const response = await axios.delete(`/banner/${id}`);
      return response.data;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },

  async create(model) {
    try {
      const response = await axios.post('/banner', model);
      return response.data;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },

  /**
   * Update by id
   * @param {number} id id of banner
   * @param {Object} model data to update
   */
  async updateById(id, model) {
    try {
      const response = await axios.put(`/banner/${id}`, model);
      return response.data;
    } catch (e) {
      console.log(e);
      throw e;
    }
  }
}

export default BannerService;
